import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Hidden,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@material-ui/lab";
import Add from "@material-ui/icons/Add";

import CustomPopperUI from "./CustomPopperUI";
import { getTasksListing } from "../../data/services/API";
import { TASK_OPTIONS, TaskType } from "../../utils/constants";
import Button from "../Button";

import { Text } from "../../components";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { getDisplayName } from "../../utils/helpers";
import { colors } from "../../theme/variables";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  switch: {
    "& .custom_popper_content": {
      width: "500px",
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  switchCaseTab: {
    padding: "4px",
  },
}));

const SwitchTaskPopperUI = (props) => {
  const classes = useStyles();
  const { setShowTasksPopper, task, updateTaskListWithTask, addTask } = props;
  const [taskArrayForSelectListing, setTaskArrayForSelectListing] = useState(
    TASK_OPTIONS
  );

  const [addNewCase, setAddNewCase] = useState(true);
  const [selectedTaskFromList, setSelectedTaskFromList] = useState(null);
  const [selectedCase, setSelectedCase] = useState(null);
  const [switchCaseName, setSwitchCaseName] = useState("");

  const [addTaskPosition, setAddTaskPosition] = useState(null);
  const [modalHeight, getModalHeight] = useState(null);
  const [modalWidth, getModalWidth] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(true);

  var anchorEl = props.anchorEl;
  var elementName = "#" + anchorEl
  // var elementName = "#" + anchorEl + ".addbtn";

  var element = document.querySelector(elementName);
  var modalElement = document.querySelector(".custom_popper_content");

  useEffect(() => {
    let timeout;
    timeout = setTimeout(() => {
      setSwitchCaseName(switchCaseName.trim());
    }, 500);
    let disableBtn = btnDisabled;
    setBtnDisabled(!switchCaseName.trim() || !selectedTaskFromList);

    return () => clearTimeout(timeout);
  }, [switchCaseName, selectedTaskFromList]);

  const switchCases = useMemo(() => {
    if (task) {
      let cases = ["Default"];
      const { decisionCases } = task;
      if (decisionCases) {
        for (const key in decisionCases) {
          cases.push(key);
        }
      }
      return cases;
    }
  }, [task]);

  function validateSwitchCases(e) {
    if (
      e?.target?.value &&
      taskArrayForSelectListing.find((obj) => obj.task === e?.target?.value)
    ) {
      setSelectedTaskFromList({
        task: e?.target?.value,
        type: selectedTaskFromList.type,
      });
      setBtnDisabled(false);
    } else if (
      e?.target?.value &&
      !taskArrayForSelectListing.find((obj) => obj.task === e?.target?.value)
    ) {
      setBtnDisabled(true);
    }
  }

  const CaseUi = useMemo(() => {
    if (addNewCase) {
      return (
        <Grid item xs={12}>
          <TextField
            id={`input-parameter-custom`}
            variant="outlined"
            label="Switch Case Name"
            fullWidth
            required={true}
            value={switchCaseName} // Set the value
            autoComplete="off"
            onChange={(e) => setSwitchCaseName(e.target.value)}
          />
        </Grid>
      );
    } else {
      return (
        <Grid item xs={12}>
          <Autocomplete
            id="custom-add-switch-case"
            options={switchCases}
            clearOnBlur={false}
            freeSolo
            getOptionLabel={(option) => option.task ?? option}
            value={selectedCase}
            onChange={(e, newVal) => setSelectedCase(newVal)}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                label="Switch Cases"
                autoComplete="off"
                variant="outlined"
                ref={params.InputProps.ref}
                InputProps={{
                  ...params.InputParams,
                  endAdornment: selectedCase && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedCase(null);
                        }}>
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      );
    }
  }, [addNewCase, switchCases, switchCaseName, selectedCase]);

  const handleAddNewCaseCheck = (e, val) => setAddNewCase(val);

  const handleSelectTask = (e, val) => {
    if (
      val &&
      !_.isString(val) &&
      val.task &&
      taskArrayForSelectListing.find((obj) => obj.task === val.task)
    ) {
      setSelectedTaskFromList(val);
      setBtnDisabled(false);
    }
    if (
      val &&
      _.isString(val) &&
      taskArrayForSelectListing.find((obj) => obj.task === val)
    ) {
      setBtnDisabled(false);
    } else if (val === "") {
      setBtnDisabled(true);
      setSelectedTaskFromList(null);
    }
  };

  const onClose = () => {
    setErrorMessage(null);
  };

  const onConfirm = () => {
    var switchTypeObj = {
      isNew: addNewCase,
      selectedCase: selectedCase,
      caseName: switchCaseName,
    };
    addTask(selectedTaskFromList, switchTypeObj);
  };
  const addSwitchCase = () => {
    if (switchCaseName.toUpperCase() === getDisplayName(TaskType.Default)) {
      setErrorMessage("Default is a reserved word");
      return;
    } else if (switchCases.includes(switchCaseName)) {
      setErrorMessage(
        "Selected case already exists. Your case will be replaced. Do you want to continue?"
      );
      return;
    } else {
      var switchTypeObj = {
        isNew: addNewCase,
        selectedCase: selectedCase,
        caseName: switchCaseName.trim(),
      };
      addTask(selectedTaskFromList, switchTypeObj);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const resp = await getTasksListing();
        const { data } = resp;
        setTaskArrayForSelectListing(data);
      } catch (error) {
        if (error.response) console.log(error.response);
      }
    })();

    return () => {};
  }, []);

  useEffect(() => {
    if (element) {
      const rect = element.getBoundingClientRect();
      setAddTaskPosition(rect);
    }
    if (modalElement) {
      const modalHeight = modalElement.clientHeight;
      const modalWidth = modalElement.clientWidth;
      getModalHeight(modalHeight);
      getModalWidth(modalWidth);
    }
  }, [element, modalElement]);
  return (
    <>
      {errorMessage && (
        <Dialog fullWidth maxWidth="sm" open={true} onClose={onClose}>
          <DialogTitle>Warning</DialogTitle>
          <DialogContent>
            <Text>{errorMessage}</Text>
          </DialogContent>
          <DialogActions>
            {errorMessage && errorMessage !== "Default is a reserved word" ? (
              <Button onClick={() => onConfirm()}>Confirm</Button>
            ) : null}

            <Button
              variant="outlined"
              color="secondary"
              style={{ color: colors.failure }}
              onClick={onClose}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <CustomPopperUI
        className={classes.switch}
        addTaskPosition={{
          'bottom':addTaskPosition?.bottom-(0.5*modalHeight),
          'left':addTaskPosition?.left
        }}
        modalHeight={modalHeight}
        modalWidth={modalWidth}>
        <Box className="custom_popper_header">
          <Grid
            container
            spacing={2}
            alignItems="flex-end"
            justifyContent="center">
            <Grid item xs={10}>
              <Box className="custom_popper_header__title">Add Task</Box>
            </Grid>
            <Grid item xs={2} className="custom_popper_close">
              {/* Close button */}
              <IconButton
                color="primary"
                className={classes.iconButton}
                aria-label="close"
                onClick={() => setShowTasksPopper(false)} // Function to close the popper
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
        <Box className={`custom_popper_task-tab ${classes.switchCaseTab}`}>
          <Grid
            container
            spacing={2}
            alignItems="flex-end"
            justifyContent="center">
            <Grid
              item
              xs={12}
              style={{
                paddingLeft: "20px",
              }}></Grid>

            {CaseUi}

            <Grid item xs={12}>
              <Autocomplete
                id="custom-add-switch-case"
                disableClearable
                options={taskArrayForSelectListing}
                clearOnBlur={false}
                freeSolo
                getOptionLabel={(option) => option.task ?? option}
                value={selectedTaskFromList}
                onChange={(e, newVal) => handleSelectTask(e, newVal)}
                onInputChange={(e, newVal) => handleSelectTask(e, newVal)}
                renderInput={(params) => (
                  <TextField
                    autoComplete="off"
                    onKeyUp={(e) => validateSwitchCases(e)}
                    onChange={(e) => validateSwitchCases(e)}
                    {...params}
                    label="Add Task"
                    required={true}
                    variant="outlined"
                    ref={params.InputProps.ref}
                    InputProps={{
                      ...params.InputParams,
                      endAdornment: selectedTaskFromList && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              handleSelectTask(null, "");
                            }}>
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                id="add-switch-button"
                disabled={btnDisabled}
                style={{ marginTop: "8px" }}
                onClick={addSwitchCase}>
                <Add /> Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      </CustomPopperUI>
    </>
  );
};

export default SwitchTaskPopperUI;
